import { Link } from "react-router-dom";
import P1 from "assets/images/p1.png";
import Drug from "assets/images/drug.png";

const prescriptions = [
  {
    id: 1,
    prescriptionNumber: 12365,
    brandName: 'Amoxicot',
    img: Drug,
    description: "Amoxicillin is an antibiotic used to treat a number of bacterial infections. These include middle ear infection, strep throat, pneumonia, skin infections, and urinary tract infections among others.[3] It is taken by mouth, or less commonly by injection.",
    name: "Amoxillin",
    tabsNo: "1 tab",
    noOfTimes: "2x daily",
    usage: "Take your antibiotics tablets two times daily along with water",
    administration: "Should be mixed with water to dilute the powdered substance."
  },
  {
    id: 2,
    prescriptionNumber: 12365,
    brandName: 'Amoxicot',
    img: Drug,
    description: "Amoxicillin is an antibiotic used to treat a number of bacterial infections. These include middle ear infection, strep throat, pneumonia, skin infections, and urinary tract infections among others.[3] It is taken by mouth, or less commonly by injection.",
    name: "Paracetamol",
    tabsNo: "1 tab",
    noOfTimes: "2x daily",
    usage: "Take your antibiotics tablets two times daily along with water",
    administration: "Should be mixed with water to dilute the powdered substance."
  },
];

const pre2 = [
  {
    prescriptionNumber: 12365,
    name: "Paracetamol",
    tabsNo: "1 tab",
    noOfTimes: "2x daily",
    usage: "Take your antibiotics tablets two times daily along with water",
  },
];

function Prescription() {
  return (
    <div className="">
      <div className="mt-5">
        <p className="text-[#1A222F] dark:text-white mb-6">04th of Apr. 2022</p>

        {prescriptions.map((prescription, i) => (
          <div className="relative mb-6 p-4 cursor-pointer" key={i}>
            <Link
              to={"/app/account/prescriptions/preview"}
              state={prescription}
            >
              <div className="absolute top-0 left-0 right-0 h-full">
                <img src={P1} alt="p1" className="w-full h-full" />
              </div>

              <div className="relative">
                <p className="text-sm font-normal dark:text-[#B3B6BA]">
                  {prescription.prescriptionNumber}
                </p>

                <div className="font-medium my-5 flex justify-between">
                  <p className="dark:text-[#F9423A]">{prescription.name}</p>
                  <div className="flex gap-x-6">
                    <p>{prescription.tabsNo}</p>
                    <p>{prescription.noOfTimes}</p>
                  </div>
                </div>
                <p className="text-sm">{prescription.usage}</p>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <div className="mt-10">
        <p className="text-[#1A222F] dark:text-white mb-6">06th of Apr. 2022</p>

        {pre2.map((prescription, i) => (
          <div className="relative mb-6 p-4 cursor-pointer" key={i}>
            <div className="absolute top-0 left-0 right-0 h-full">
              <img src={P1} alt="p1" className="w-full h-full" />
            </div>

            <div className="relative">
              <p className="text-sm font-normal">
                {prescription.prescriptionNumber}
              </p>

              <div className="font-medium my-5 flex justify-between">
                <p>{prescription.name}</p>
                <div className="flex gap-x-6">
                  <p>{prescription.tabsNo}</p>
                  <p>{prescription.noOfTimes}</p>
                </div>
              </div>
              <p className="text-sm">{prescription.usage}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Prescription;
